import React, { FunctionComponent, useRef, useState } from "react";
import { useClickAway } from "react-use";
import useFunctionThrottling from "../../../hooks/useFunctionThrottling";
import "./ContactUsCallUs.scss";
import { Image } from "@sitecore-jss/sitecore-jss-react";

interface CallNumber {
  label: string;
  number: string;
}

interface ContactUsCallUsProps {
  callLabel: string;
  callSubtitle: string;
  callNumbersList: Array<CallNumber>;
  IconImage?: { value: { alt: string; src: string } };
}

const ContactUsCallUs: FunctionComponent<ContactUsCallUsProps> = ({
  callLabel,
  callSubtitle,
  callNumbersList,
  IconImage,
}) => {
  const [callUsOpen, setCallUsOpen] = useState<boolean>(false);
  const [selectedCallPhone, setSelectedCallPhone] = useState<string>("");

  const toggleCallMenu = useFunctionThrottling<null>(
    () => setCallUsOpen(!callUsOpen),
    200
  );

  const menuRef = useRef<HTMLDivElement>();
  useClickAway(menuRef, () => (callUsOpen ? toggleCallMenu(null) : () => {}));

  const handleCallUsPress: () => void = () => {
    if (selectedCallPhone.length === 0) toggleCallMenu(null);
    else window.open(`tel:${selectedCallPhone}`, "_self");
  };

  const handleCallCountryPress: (country: string) => void = (country) => {
    setSelectedCallPhone(country);
    toggleCallMenu(null);
  };

  return (
    <div className="contactUsCallUs_call_us_container">
      <div onClick={handleCallUsPress}>
        <span>
          <span className="icon-phone" />

          {selectedCallPhone.length === 0 ? (
            <>
              <h6>{callLabel}</h6>

              <p>{callSubtitle}</p>
            </>
          ) : (
            <div className="contactUsCallUs_call_us_number">
              {selectedCallPhone}
            </div>
          )}
        </span>

        <div
          ref={menuRef}
          className={
            callUsOpen
              ? "contactUsCallUs_expandible_menu contactUsCallUs_expandible_menu_open"
              : "contactUsCallUs_expandible_menu"
          }
        >
          {callNumbersList.map((number, idx) => (
            <div
              key={idx}
              onClick={() => {
                handleCallCountryPress(number.number);
              }}
            >
              {number.label}
            </div>
          ))}
        </div>
      </div>

      <button style={{ padding: 0 }} onClick={toggleCallMenu} type="button">
        <Image field={IconImage} />
      </button>
    </div>
  );
};

export default ContactUsCallUs;
